import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';

export const useTranslation = () => {
  const { language } = useLanguage();
  
  const t = (key, options = undefined) => {
    const dictionary = translations[language] || {};
    const isOptionsObject = typeof options === 'object' && options !== null;
    const fallback = isOptionsObject ? options.fallback : options;
    const values = isOptionsObject ? options.values : undefined;

    let value = dictionary[key] ?? fallback ?? key;

    if (values && typeof value === 'string') {
      Object.entries(values).forEach(([token, tokenValue]) => {
        const regex = new RegExp(`{${token}}`, 'g');
        value = value.replace(regex, tokenValue);
      });
    }
    
    return value;
  };
  
  return { t, language };
};
